module.exports = __webpack_public_path__ + "img/stop.a7f61897.svg";